import { DataSyncRunSchema } from '../../shared/data-sync';
import { ApplyDataSyncRequestSchema } from './apply-data-sync.schema';
export const applyDataSyncContract = {
    method: 'POST',
    path: '/api/v2/data-sync/runs/:id/apply',
    description: 'Apply the selected differences of a sync run in review',
    requestSchema: ApplyDataSyncRequestSchema,
    responseSchema: DataSyncRunSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - not allowed to manage the data source',
            404: 'Not Found - sync run not found',
            409: 'Conflict - the run is not in review, the selection is invalid, a sync run is running, the run lost its lock (stale), or the run is a Personio run and Personio is not linked'
        }
    }
};
export const retryDataSyncContract = {
    method: 'POST',
    path: '/api/v2/data-sync/runs/:id/retry',
    description: 'Write the failed differences of a done sync run again',
    responseSchema: DataSyncRunSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - not allowed to manage the data source',
            404: 'Not Found - sync run not found',
            409: 'Conflict - the run is not done with failed outcomes, a later run superseded it, a sync run is running, the run lost its lock (stale), or the run is a Personio run and Personio is no longer linked'
        }
    }
};

//# sourceMappingURL=apply-data-sync.contract.js.map